import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import toll_logo from "../tge-logo-lockup-white.svg";
import { AppStateContext } from "../Contexts/AppStateContext";
import { UserDataContext } from "../Contexts/UserDataContext";

import HomeIcon from "@material-ui/icons/Home";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
    textAlign: "left",
  },
  menuIcon: {
    width: "auto",
    height: "50px",
    padding: theme.spacing(1),
    '& img': {
      width: "100%",
      height: "100%",     
    }
  }
}));

const ButtonAppBar = () => {
  const classes = useStyles();
  const { appState, setAppState, clearScrollPosition } =
    useContext(AppStateContext);
  const { userData, logout } = useContext(UserDataContext);
  const history = useHistory();

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar>
        <IconButton
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="menu"
          onClick={() => setAppState({ ...appState, menuOpen: true })}
        >
          <MenuIcon />
        </IconButton>

        <div className={classes.menuIcon}>
          <img src={toll_logo} alt="toll logo" />
        </div>

        <div className={classes.title}>
          <IconButton
            color="inherit"
            onClick={() => {
              clearScrollPosition();
              history.push(`/${userData.userName}/dashboard`);
            }}
          >
            <HomeIcon />
          </IconButton>
        </div>

        <Button onClick={logout} color="inherit">
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default ButtonAppBar;
